/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFiltrosItem from './entidades/filtrosItem';
import IItem from './entidades/item';
import IItemCompuesto from './entidades/itemCompuesto';
import IParametrosItem from './entidades/parametrosItem';
import IProductoPrincipal from './entidades/productoPrincipal';

export default class ModeloProducto {
    public consultarListaProductoPrincipal(parametros: IParametrosItem) {
        return manejadorRest<IRespuestaPaginada<IProductoPrincipal>>(
            () => negocio.post('Item/ConsultarListaItemCompuestos', parametros),
            true
        );
    }

    public consultarItemPorCodigoBarras(codigoBarras: string) {
        return manejadorRest<IRespuesta<IProductoPrincipal>>(
            () => negocio.get(`Item/ConsultarItemPorCodigoBarras?CodigoBarras=${codigoBarras}`),
            true
        );
    }

    public consultarListaItemsPorFiltro(filtros: IFiltrosItem) {
        return manejadorRest<IRespuesta<IProductoPrincipal>>(
            () => negocio.post('Item/ConsultarListaItemCompuestosFiltro', filtros),
            true
        );
    }

    public guardarItemUnidades(ItemCompuesto: IItemCompuesto) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocio.post('Item/GuardarItemUnidad', ItemCompuesto),
            true
        );
    }

    public editarItemUnidades(ItemCompuesto: IItemCompuesto) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocio.put('Item/EditarItemUnidad', ItemCompuesto),
            true
        );
    }

    public eliminarItem(item: IItem) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocio.delete('Item/EliminarItemCompuesto', item),
            true
        );
    }

    public consultarListaItems() {
        return manejadorRest<IRespuesta<IItem>>(() => negocio.get('Item/ConsultarListaItem'), true);
    }
}
